module.exports = __webpack_public_path__ + "static/media/gradient06.ea3e7464.jpg";